<template>
  <div class="space-y-32">
    <h1 class="heading-1">
      {{ i18n(translations.title) }}
    </h1>
    <div class="space-y-16">
      <div class="body-1">{{ i18n(translations.notEligibleMessage) }}</div>

      <RevButton
        full-width="always"
        :to="resolveLocalizedRoute({ name: CHECKOUT.CART })"
        variant="primary"
      >
        {{ i18n(translations.goToCart) }}
      </RevButton>

      <RevButton
        full-width="always"
        :to="resolveLocalizedRoute({ name: HOME })"
        variant="secondary"
      >
        {{ i18n(translations.continueShopping) }}
      </RevButton>
    </div>
    <div class="flex justify-center">
      <RevIllustration
        :alt="i18n(translations.emptyBasketIcon)"
        class="py-44"
        :height="223"
        src="/img/bouygues/emptyBasket.svg"
        :width="236"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouteLocationWithLocale } from '#imports'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import { CHECKOUT } from '~/scopes/checkout/routes-names'
import { HOME } from '~/scopes/home/route-names'

import translations from './NotEligible.translations'

const i18n = useI18n()
const resolveLocalizedRoute = useRouteLocationWithLocale()
</script>
